import { apiService } from './api';
import { CreateCustomerRequest, UpdateCustomerRequest, CustomersResponse, CustomerResponse } from '@/types/customer';

export class CustomerService {
  /**
   * Get all customers with optional filters
   */
  async getCustomers(params?: { isActive?: boolean; categoryIds?: string }): Promise<CustomersResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.isActive !== undefined) {
      queryParams.append('isActive', params.isActive.toString());
    }
    
    if (params?.categoryIds) {
      queryParams.append('categoryIds', params.categoryIds);
    }
    
    const url = queryParams.toString() ? `/customers?${queryParams.toString()}` : '/customers';
    return apiService.get<CustomersResponse>(url);
  }

  /**
   * Get a single customer by ID
   */
  async getCustomer(id: string): Promise<CustomerResponse> {
    return apiService.get<CustomerResponse>(`/customers/${id}`);
  }

  /**
   * Create a new customer
   */
  async createCustomer(customerData: CreateCustomerRequest): Promise<CustomerResponse> {
    return apiService.post<CustomerResponse>('/customers', customerData);
  }

  /**
   * Update an existing customer
   */
  async updateCustomer(id: string, customerData: UpdateCustomerRequest): Promise<CustomerResponse> {
    return apiService.put<CustomerResponse>(`/customers/${id}`, customerData);
  }

  /**
   * Delete a customer
   */
  async deleteCustomer(id: string): Promise<{ success: true; message: string }> {
    return apiService.delete<{ success: true; message: string }>(`/customers/${id}`);
  }
}

export const customerService = new CustomerService();